module.exports = __webpack_public_path__ + "img/intro.2267c007.jpg";